import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

import { quoteType } from './Quote';

const getTypedBackgroundColor = displayType => {
    switch(displayType) {
        case quoteType.WHITE:
            return '#FFFFFF';
        case quoteType.GREY:
            return '#F2F2F2';
        case quoteType.RED:
            return '#D2614F';
        default:
            return '#FFFFFF';
    }    
};

const getTypedColor = displayType =>
    displayType === quoteType.RED ? '#FFF' : '#333';

export const Wrapper = styled.div`
    padding: 50px 20px;
    background-color: ${({displayType}) => getTypedBackgroundColor(displayType)};
    position: relative;
    overflow: hidden;
    display: ${({displayType}) => displayType === quoteType.WHITE ? 'flex' : 'block' }
`;

export const QuoteColumn = styled.div`
    flex: 0 0 50px;
    align-self: flex-start;
    justify-self: flex-start;
    
    svg {
        margin-top: 10px;
        max-width: 100%;
        height: auto;

        path {
            fill: #C73B24;
        }
    }

    ${breakpoint('tablet')`
        flex: 0 0 80px;
    `}
`

export const QuoteBackground = styled.span`
    position: absolute;
    left: -15px;
    bottom: -15px;
    height: auto;
    width: 300px;
    
    svg {
        margin-top: 10px;
        max-width: 100%;
        height: auto;

        path {
            fill: rgba(255, 255, 255, .4);
        }
    }
`

export const TextWrapper = styled.div`
    max-width: ${({displayType}) => displayType === quoteType.WHITE ? '100%' : '700px'};
    margin: ${({displayType}) => displayType === quoteType.WHITE ? '0 auto 0 20px' : '0 auto'};
    position: relative;
    z-index: 1;

    ${breakpoint('tablet')`
        margin: ${({displayType}) => displayType === quoteType.WHITE ? '0 auto 0 30px' : '0 auto'};
    `}
`;

export const Text = styled.div`
    color: ${({displayType}) => getTypedColor(displayType)};
    font-size: 24px;
    font-weight: 300;
    margin-bottom: 15px;
    line-height: 1.6em;
    text-align: ${({displayType}) => displayType === quoteType.GREY ? 'center' : 'left' };

    ${breakpoint('tablet')`
        font-size: 30px;
        text-align: ${({displayType}) => displayType === quoteType.GREY ? 'center' : 'left' };
    `}
`;

export const Author = styled.p`
    text-align: left;
    font-size: 18px;
    font-weight: 300;
    display: block;
    text-align: ${({displayType}) => displayType === quoteType.GREY ? 'center' : 'left' };
    color: ${({displayType}) => getTypedColor(displayType)};

    ${breakpoint('tablet')`
        text-align: ${({displayType}) => displayType === quoteType.GREY ? 'center' : 'left' };
    `}
`;